export const message = {
  saveDraftColumnView: 'Reports Layout successfully saved',
  publishDraftColumnView: 'Reports Layout successfully published'
}